import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { cnBem } from '@carnica/utils';
import { Avatar, Button, Cell, Text } from '@carnica/ui-kit';
import { IconSettingsFilled } from '@carnica/graphics';
import { withRenderFlag } from '@beef/react';
import styles from "./styles.pcss";
import { AccountsMapper } from "./components/AccountsMapper";
import { ChangeAccountModal } from "../ChangeAccountModal";
var cnLinkedAccounts = cnBem('linked-accounts', styles);
export var _LinkedAccounts = function _LinkedAccounts(_ref) {
  var _window;
  var accounts = _ref.accounts,
    baseUrl = _ref.baseUrl,
    defaultAccountsText = _ref.defaultAccountsText;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isModalOpen = _useState2[0],
    setIsModalOpen = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    account = _useState4[0],
    setAccount = _useState4[1];
  var handleSwitchAccount = function handleSwitchAccount(value) {
    setAccount(value);
    setIsModalOpen(true);
  };
  var handleAddAccount = function handleAddAccount() {
    window.location.href = "".concat(baseUrl, "tab/settings/general/?addAccount");
  };
  var Conditional = withRenderFlag(React.Fragment);
  return /*#__PURE__*/React.createElement("div", {
    className: cnLinkedAccounts(null, ['container']),
    "data-t-id": "components-LinkedAccounts"
  }, /*#__PURE__*/React.createElement("div", {
    className: cnLinkedAccounts(null, ['title-bar'])
  }, /*#__PURE__*/React.createElement(Text, {
    size: "s"
  }, "\u0443\u043F\u0440\u0430\u0432\u043B\u044F\u044E \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430\u043C\u0438"), /*#__PURE__*/React.createElement("div", {
    className: cnLinkedAccounts(null, ['settings-icon'])
  }, /*#__PURE__*/React.createElement("a", {
    "aria-label": "settings",
    href: "".concat((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.origin, "/customers/products/elk/tab/settings/general")
  }, /*#__PURE__*/React.createElement(IconSettingsFilled, {
    color: "tertiary",
    size: 24
  })))), /*#__PURE__*/React.createElement(Conditional, {
    shouldRender: accounts.length > 0
  }, /*#__PURE__*/React.createElement(AccountsMapper, {
    accounts: accounts,
    "data-t-id": "components-LinkedAccounts"
  }, function (accountItem) {
    return /*#__PURE__*/React.createElement(Cell, {
      className: cnLinkedAccounts(null, ['account-item']),
      leftSide: /*#__PURE__*/React.createElement(Avatar, {
        image: accountItem.avatar
      }),
      onClick: function onClick() {
        return handleSwitchAccount(accountItem);
      },
      subTitle: accountItem === null || accountItem === void 0 ? void 0 : accountItem.nickname,
      tagName: "button",
      title: (accountItem === null || accountItem === void 0 ? void 0 : accountItem.formattedAccountNumber) || (accountItem === null || accountItem === void 0 ? void 0 : accountItem.formattedNumber)
    });
  })), /*#__PURE__*/React.createElement(Conditional, {
    shouldRender: accounts.length === 0
  }, /*#__PURE__*/React.createElement("div", {
    className: cnLinkedAccounts(null, ['no-accounts']),
    "data-t-id": "components-LinkedAccounts"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "tertiary",
    size: "xs"
  }, defaultAccountsText))), /*#__PURE__*/React.createElement(Button, {
    className: cnLinkedAccounts(null, ['add-account-button']),
    onClick: handleAddAccount,
    width: "full"
  }, "\u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C"), /*#__PURE__*/React.createElement(ChangeAccountModal, {
    account: account,
    isOpen: isModalOpen,
    setIsOpen: setIsModalOpen
  }));
};
export var LinkedAccounts = withRenderFlag({
  shouldRenderFn: function shouldRenderFn() {
    return typeof window !== 'undefined';
  }
})(_LinkedAccounts);